import { gql } from '@apollo/client';

/**
 * Recsys D17 grading — colocated with GradeWidget rather than reused from
 * Pages/candidate-recommendations/gql.ts, since grading is self-contained and
 * only ever rendered inside CandidateWorkspacePanel.
 *
 * Reads the single SHARED grade for (jobOrderId, candidateId) — one grade per
 * pair, not per-recruiter. Resolves to null when the pair is ungraded; the
 * widget relies on that null (does NOT default to 0) to render its "ungraded"
 * state. JWT-guarded; authz asserts job + private-candidate access before
 * returning, even for a null result.
 */
export const RECSYS_GRADE = gql`
  query RecsysGrade($jobOrderId: String!, $candidateId: String!) {
    recsysGrade(jobOrderId: $jobOrderId, candidateId: $candidateId) {
      id
      grade
      note
      gradedByUserId
      updatedAt
    }
  }
`;

/**
 * Upserts the shared grade by unique (jobOrderId, candidateId) — last edit
 * wins, gradedByUserId is set to the acting (last) user. grade is required
 * (validated 0-3 server-side); note is optional, trimmed, single-line.
 */
export const SAVE_RECSYS_GRADE = gql`
  mutation SaveRecsysGrade($jobOrderId: String!, $candidateId: String!, $grade: Int!, $note: String) {
    saveRecsysGrade(jobOrderId: $jobOrderId, candidateId: $candidateId, grade: $grade, note: $note) {
      id
      grade
      note
      gradedByUserId
      updatedAt
    }
  }
`;
